import { IFeet } from '@/types/generic.types';

export const inchesToFeet = (inches: number): IFeet => {
  const feet = Math.floor(inches / 12);
  const remainingInches = inches % 12;

  return {
    feet,
    inches: remainingInches,
  };
};
